var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2478_8182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9594 22.0039H4.49662C4.22251 22.0039 4 22.2262 4 22.5005C4 22.7746 4.2223 22.9972 4.49662 22.9972H21.9594C22.2335 22.9972 22.456 22.7749 22.456 22.5005C22.456 22.2262 22.2337 22.0039 21.9596 22.0039H21.9594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2286 10.6253C15.2594 10.6253 16.8929 8.03848 16.8929 5.89852C16.8929 3.78831 15.2493 2.07544 13.2286 2.07544C11.2127 2.07544 9.56934 3.78831 9.56934 5.89852C9.56915 8.03848 11.2028 10.6253 13.2286 10.6253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09003 8.11308H8.54683C8.81999 8.11308 9.04345 7.89459 9.04345 7.61645V4.60253C9.04345 4.37909 8.89944 4.19545 8.70571 4.13583C8.93906 2.57174 10.3492 0.992974 12.1714 0.992974H14.2916C15.2002 0.992974 16.0742 1.3951 16.7594 2.12505C17.2956 2.70107 17.6482 3.41104 17.7524 4.13583C17.5586 4.19546 17.4148 4.37909 17.4148 4.60253V7.61645C17.4148 7.89457 17.6383 8.11308 17.9114 8.11308H18.3682C19.5449 8.11308 20.5032 7.21434 20.5032 6.1122C20.5032 5.13402 19.7535 4.31477 18.7605 4.14102C18.6464 3.16781 18.1945 2.20968 17.4794 1.44485C17.0474 0.978149 16.546 0.615644 16.0046 0.372404C15.4634 0.129149 14.8825 0 14.2916 0H12.1714C9.77812 0 7.94602 2.10031 7.6978 4.14103C6.70972 4.31476 5.95996 5.13403 5.95996 6.11221C5.95996 7.2144 6.91317 8.11309 8.09002 8.11309L8.09003 8.11308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55958 20.1241C6.73826 20.8936 7.51791 21.4497 8.41645 21.4497H18.0388C18.9375 21.4497 19.722 20.8937 19.8957 20.1439L21.127 15.6752C21.2064 15.3325 21.1668 14.9851 21.0077 14.6772H5.45215C5.29329 14.99 5.24852 15.3377 5.33291 15.695L6.55958 20.1241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75488 13.6841H18.7031C18.0031 12.6911 16.8512 11.708 15.5353 11.708H10.9226C9.60215 11.708 8.45027 12.6911 7.75498 13.6841H7.75488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2478_8182",
    x: 0,
    y: 0,
    width: 26.4561,
    height: 30.9971,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_8182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2478_8182",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceWhite);
export default __webpack_public_path__ + "static/media/ServiceWhite.789c7563c7d8aa43e5fafed5e87fa802.svg";
export { ForwardRef as ReactComponent };